export default {
    methods: {
        async logout() {
            this.$store.dispatch('global_loading/changeLoadingStatus', true);
            await this.$store.dispatch('auth/logout');
            this.$router.go();
        },
    },
};
